import React from 'react';
import config from 'react-global-configuration';

import NodeHomePageFull from './Full';
import NodeHomePageNLdoet from './NLdoet';
import NodeHomePageMaatjes from './Maatjes';
import NodeHomePageAppeltjes from './Appeltjes';

import { MAATJES_DOMAIN, NLDOET_DOMAIN, APPELTJES_DOMAIN } from '../../../config/constants';

const NodeHomePage = (props) => {
  const currentDomain = config.get('CURRENT_DOMAIN');

  switch (currentDomain) {
    case MAATJES_DOMAIN:
      return <NodeHomePageMaatjes {...props} />;
    case NLDOET_DOMAIN:
      return <NodeHomePageNLdoet {...props} />;
    case APPELTJES_DOMAIN:
      return <NodeHomePageAppeltjes {...props} />;
    default:
      return <NodeHomePageFull {...props} />;
  }
};

export default NodeHomePage;
